export default __webpack_public_path__ + "static/media/index-fund-banners-2-xs.d26c0fef.png";